import { useNavigate } from "@tanstack/react-router";

import { cn } from "@/lib/classNames";

export type BetaBadgeProps = {
  className?: string;
};

export default function BetaBadge({ className }: BetaBadgeProps) {
  const navigate = useNavigate();

  function handleClick() {
    void navigate({
      to: ".",
      search: (current: Record<string, unknown>) => ({
        ...current,
        feedback: "open",
      }),
    });
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Open beta feedback"
      data-testid="beta-badge"
      className={cn(
        "inline-flex select-none items-center gap-1.5 rounded-full border border-amber-300/60 bg-amber-400/90 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.22em] text-neutral-950 shadow-lg backdrop-blur-md transition-colors hover:bg-amber-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neutral-950",
        className,
      )}
    >
      <span
        aria-hidden
        className="inline-block h-1.5 w-1.5 rounded-full bg-neutral-950"
      />
      Beta · Feedback
    </button>
  );
}
